import { render, staticRenderFns } from "./InfoBtn.vue?vue&type=template&id=4dd56dbd"
import script from "./InfoBtn.vue?vue&type=script&lang=js"
export * from "./InfoBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports